import { AlertButtonResult, AlertOptions } from '@flash-global66/g-dialog-alert';
import { Router } from 'vue-router';

type onButtonAlertCloseTransactionType = AlertButtonResult & {
  router: Router;
};

export const alertClosePinTransaction: AlertOptions = {
  type: 'warning',
  title: 'Confirmar cancelación',
  description:
    '¿Estás seguro de que deseas cancelar la transacción? Podrás iniciar un nuevo proceso más tarde si lo necesitas.',
  primaryText: 'Volver',
  secondaryText: 'Cancelar transacción',
};

export const alertForgotPinTransaction: AlertOptions = {
  type: 'warning',
  title: 'Confirmar recuperación de PIN',
  description:
    'Ten en cuenta que el cambio de PIN cancelará tu transacción actual',
  primaryText: 'Volver',
  secondaryText: 'Cambiar PIN',
};

export function onButtonAlertCloseTransaction({
  isPrimary,
  isSecondary,
  router
}: onButtonAlertCloseTransactionType): void { 
  if (isPrimary) return;

  if (isSecondary) {
    router.push({ name: 'movements' });
    return; 
  } 
  return; 
}
